import { Alert, TextInput } from 'corso-admin-ui';
import { CrewIncentiveTypeEnum, toEnum } from 'corso-types';
import { Controller } from 'react-hook-form';
import MonetaryRateInput, {
  MonetaryType,
} from '~/components/field/MonetaryRateInput';
import { useAutomationFormContext } from '~/features/settings/automations/hooks/useAutomationForm';
import { useCurrency } from '~/hooks/useCurrency';

export default function EventApplyFee() {
  const { control, watch, setValue, getFieldState } =
    useAutomationFormContext();

  const { currencyCode, currencySymbol } = useCurrency();

  const feeAmount = watch('event.params.feeAmount');
  const incentiveType = watch('event.params.feeType');

  return (
    <>
      {feeAmount === 0 ? (
        <Alert heading="Fees Are Waived" />
      ) : (
        <Alert
          variant="tip"
          heading="To waive fees, set the fee amount to 0."
        />
      )}

      <MonetaryRateInput
        id="fee-amount"
        label="Fee Amount"
        labelVisuallyHidden
        details="The amount to apply as a fee, Percent based fees are calculated on the value of the claimed items."
        required
        defaultValue={1}
        currencyCode={currencyCode}
        currencySymbol={currencySymbol}
        value={{
          type:
            incentiveType === CrewIncentiveTypeEnum.none
              ? CrewIncentiveTypeEnum.fixed
              : toEnum(incentiveType, MonetaryType),
          amount: feeAmount,
        }}
        onChange={({ type, amount }) => {
          setValue('event.params.feeAmount', amount, {
            shouldDirty: true,
            shouldValidate: true,
            shouldTouch: true,
          });
          setValue('event.params.feeType', type, {
            shouldDirty: true,
            shouldValidate: true,
            shouldTouch: true,
          });
        }}
        error={
          getFieldState('event.params.feeAmount').error?.message ??
          getFieldState('event.params.feeType').error?.message
        }
      />

      <Controller
        control={control}
        name="event.params.feeDisplayName"
        render={({ field, fieldState }) => (
          <TextInput
            id="fee-display-name"
            label="Display Name"
            details="The name of the fee, this will be shown to the customer."
            required
            {...field}
            error={fieldState.error?.message}
          />
        )}
      />
    </>
  );
}
